import React from "react";
import { Dropdown, Form, InputGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../redux/actions/authActions";

function titleFromPath(pathname) {
  if (pathname.startsWith("/dashboard")) return "Dashboard";
  if (pathname.startsWith("/categories")) return "Categories";
  if (pathname.startsWith("/gems")) return "Gems";
  return "Rock Dashboard";
}

export default function Topbar() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const title = titleFromPath(location.pathname);

  return (
    <header className="navbar navbar-expand-md d-none d-lg-flex d-print-none">
      <div className="container-fluid">
        <div className="navbar-nav flex-row order-md-last align-items-center gap-2">
          <button
            type="button"
            className="songsnap-icon-button"
            aria-label="Notifications"
          >
            <span className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3H4a4 4 0 0 0 2-3v-3a7 7 0 0 1 4-6" />
                <path d="M9 17v1a3 3 0 0 0 6 0v-1" />
              </svg>
            </span>
          </button>

          <Dropdown align="end">
            <Dropdown.Toggle
              variant="link"
              className="songsnap-icon-button text-decoration-none d-flex align-items-center gap-2"
            >
              <span
                className="avatar avatar-sm rounded-circle"
                style={{ background: "var(--accent-bg-active)", color: "var(--accent-fg)" }}
                aria-hidden="true"
              >
                A
              </span>
              <span className="d-none d-xl-inline text-muted fw-semibold">
                Admin
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => navigate("/profile")}>
                My Profile
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                onClick={() => {
                  dispatch(logout());
                  navigate("/login");
                }}
              >
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="navbar-nav flex-row align-items-center gap-3">
          <div className="nav-item">
            <div className="fw-bold">{title}</div>
          </div>

          <div className="nav-item flex-grow-1" style={{ minWidth: 280, maxWidth: 520 }}>
            <Form role="search" onSubmit={(e) => e.preventDefault()}>
              <InputGroup>
                <InputGroup.Text aria-hidden="true">
                  <span className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="11" cy="11" r="8" />
                      <path d="m21 21-4.3-4.3" />
                    </svg>
                  </span>
                </InputGroup.Text>
                <Form.Control
                  className="control"
                  placeholder="Search..."
                  aria-label="Search"
                />
              </InputGroup>
            </Form>
          </div>
        </div>
      </div>
    </header>
  );
}

